module.exports = __webpack_public_path__ + "img/image 1133@2x.8d90ab87.png";